// IE 2026 09 26 / ODOO-5800 (находка ie-demo7 26.09 16:07Z на Demo, verify-cacheguard-2026-09-26.md): ОТМЕНА ЗАПРОСОВ БЭКА — номер действия
// уникален на вкладку, ответ 204 не роняет виджет.
//
// Что было. Номер действия (action_id_front) — счётчик вкладки с нуля (mainStore.action_id_front, ++ на каждое действие). Бэк держит по нему
// признак отмены в общем кэше: запрос ставит «в работе», запрос с del_last_backend_action (кнопка Stop и уход со страницы — widget_stopLoading,
// новый запрос виджета при незавершённом прежнем — executeWidgetMethod) ставит «отменён», бегущий запрос по нему останавливается и отвечает 204.
// Кэш один на все бэкенды хоста, номер голый — отмена ЛЮБОЙ вкладки любого пользователя с тем же номером обрывала чужой запрос (Demo: 3 select'а
// агента получили 204 от отмен пользователя app.webscm.ai). Фронт на 204 падал: jQuery зовёт success без тела, store.TERMINAL читал
// answer.BACKEND_duration → TypeError, до WIDGET.loading = false дело не доходило — виджет висел в загрузке (~10 мин).
//
// Что стало.
//   fe.net.actionIdUnique (по умолчанию ВКЛ): на бэк номер уходит строкой '<вкладка>-<N>' (NET_TAB_ID — случайный на загрузку страницы);
//     внутри фронта номер остаётся числом (сравнения «поздний ответ отбрасываем» last_backend_action > action_id_front — как были).
//     Со старым бэком работает так же: строка — такой же ключ кэша, как число.
//   fe.net.cancel204Safe (по умолчанию ВКЛ): ответ 204 (запрос отменён на бэке, а фронт его не обрывал — значит, отменил не он) — без TypeError:
//     виджет выходит из загрузки, прогресс гаснет, плашка-предупреждение; скелет первого открытия переоткрывается «только вид» (как после Stop);
//     executeBackendMethod на 204 — как на ошибку, без колбэка и без красной плашки. Ответ устаревшего запроса (виджет уже ждёт более нового) — молча.
//   fe.net.cancelKeyScoped (по умолчанию ВКЛ): OFF — фронт шлёт бэку выключатель debug_flags['not-cancel_key_scoped'] (голый ключ отмены на бэке,
//     как было; см. be-ie common_modules/cancel_key.py) — во всех запросах, несущих номер действия или отмену, чтобы запрос и его отмена совпадали.
//
// Выключатели (реестр feSettings): window.feSettings.set('fe.net.actionIdUnique', false) … или ?fe.net.actionIdUnique=false в URL;
// консоль: window.netCancel.get() / .set('actionIdUnique', false) / .reset() / .stats() / .clear().
// Замеры (stats): сколько номеров и отмен ушло (из них уникальными), сколько пришло 204 и сколько из них обработано безопасно; последний 204.
import { t } from '@/i18n'

export const FLAG_UNIQUE = 'fe.net.actionIdUnique'
export const FLAG_204 = 'fe.net.cancel204Safe'
export const FLAG_SCOPED = 'fe.net.cancelKeyScoped'
const FLAGS = { actionIdUnique: FLAG_UNIQUE, cancel204Safe: FLAG_204, cancelKeyScoped: FLAG_SCOPED }

// идентификатор загрузки страницы: новая вкладка / перезагрузка — новый префикс (счётчик тоже с нуля)
export const NET_TAB_ID = (() => {
    try {
        const a = new Uint32Array(2)
        crypto.getRandomValues(a)
        return (a[0].toString(36) + a[1].toString(36)).slice(0, 10)
    } catch (e) {
        return (Math.random().toString(36).slice(2) + Date.now().toString(36)).slice(0, 10)
    }
})()

const stats = {
    actions: 0, actionsUnique: 0,    // номера действий, ушедшие на бэк (из них в виде '<вкладка>-<N>')
    cancels: 0, cancelsUnique: 0,    // отмены (del_last_backend_action)
    r204: 0, r204Handled: 0,         // ответы 204 / из них обработаны безопасно (fe.net.cancel204Safe)
    last204: null,
}

const on = (store, key) => store.setting(key, true) !== false
const NOTICE_204 = () => t('The request was cancelled on the server. Press Update to load the data again.')

// номер действия / отмены в том виде, в каком он уходит на бэк; внутри фронта номер — число
export function net_actionId(store, n, kind = 'action') {
    if (n === null || n === undefined || n === '' || n === 0 || n === false) return n
    const cancel = kind === 'cancel'
    stats[cancel ? 'cancels' : 'actions']++
    if (typeof n !== 'number' || !on(store, FLAG_UNIQUE)) return n
    stats[cancel ? 'cancelsUnique' : 'actionsUnique']++
    return `${NET_TAB_ID}-${n}`
}

// выключатель ключа отмены бэка (правило 8: переключение целиком клиентское)
export function net_requestParams(store) {
    return on(store, FLAG_SCOPED) ? {} : { debug_flags: { 'not-cancel_key_scoped': true } }
}

// ответ 204 «POST CANCELLED»: true — обработан (вызывающий выходит из success), false — флаг выключен, прежний путь
export function net_on204(store, WIDGET, opts = {}) {
    const where = opts.where || ''
    stats.r204++
    stats.last204 = { at: new Date().toISOString(), where, widget: WIDGET?.id ?? null, action: opts.action?.action_id_front ?? opts.actionId ?? null,
        method: opts.action?.method || '', superseded: !!opts.superseded, handled: false }
    if (!on(store, FLAG_204)) return false
    stats.r204Handled++
    stats.last204.handled = true
    console.warn(`[${WIDGET?.id ?? '-'}][${stats.last204.action ?? ''}]${where} ${stats.last204.method} 204: request cancelled on the server${opts.superseded ? ' (superseded — a newer request is pending)' : ''}`)
    if (!WIDGET || opts.superseded) return true
    try { store.report_progress_stop(WIDGET) } catch (e) { /* без прогресса */ }
    WIDGET.loading = false
    if (where === 'widget_open' && WIDGET.firstBackendCheck && typeof WIDGET._widgetOpen_repeat === 'function' && !WIDGET._net204Reopen) {
        // скелет первого открытия: как после Stop — переоткрыть «только вид» (настройки доступны, данных нет); один раз на виджет
        WIDGET._net204Reopen = true
        WIDGET._net204Notice = NOTICE_204()   // плашка — ПОСЛЕ ответа переоткрытия: его Object.assign(WIDGET, answer.WIDGET) заменяет notification
        WIDGET._open_view_only = true
        try { WIDGET._widgetOpen_repeat() } finally { WIDGET._open_view_only = false }
    } else if (WIDGET.firstBackendCheck) {
        WIDGET.firstBackendCheck = false
    }
    WIDGET.notification = { ...(WIDGET.notification || {}), visible: true, status: 'warning', header: '', text: NOTICE_204() }
    WIDGET.vueObj?.$forceUpdate?.()
    return true
}

export function netCancel_console(store) {
    if (typeof window === 'undefined') return
    const flags = () => Object.fromEntries(Object.entries(FLAGS).map(([k, key]) => [k, on(store, key)]))
    window.netCancel = {
        flags: FLAGS,
        tabId: NET_TAB_ID,
        get: () => ({ ...flags(), tabId: NET_TAB_ID, counter: store.action_id_front, stats: { ...stats } }),
        set(name, value) {
            const key = FLAGS[name] || name
            if (!Object.values(FLAGS).includes(key)) return { error: `netCancel: no option '${name}'`, options: Object.keys(FLAGS) }
            window.feSettings?.set?.(key, value)
            return this.get()
        },
        reset() { for (const key of Object.values(FLAGS)) window.feSettings?.unset?.(key); return this.get() },
        stats: () => ({ ...stats }),
        clear() { for (const k of Object.keys(stats)) stats[k] = k === 'last204' ? null : 0; return { ...stats } },
        help: () => 'netCancel.set("actionIdUnique" | "cancel204Safe" | "cancelKeyScoped", false) — прежнее поведение; .reset() — снять override; .stats() / .clear() — счётчики',
    }
}
